import { isAction, Middleware } from '@reduxjs/toolkit';
import { AuthService, UserService } from '@/services';
import { allServices } from './servicesReducer';

const RESET_ON_ACTION_TYPES = new Set(['auth/login', 'auth/logout']);

export const resetApiCachesOnAuthChange: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (isAction(action) && RESET_ON_ACTION_TYPES.has(action.type)) {
      [...allServices, AuthService, UserService].forEach((service) => {
        if (service) store.dispatch(service.util.resetApiState());
      });
    }

    return result;
  };
